export default "__VITE_ASSET__BV0Gy983__"